import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../lib/api';
import { useLanguage } from '../context/LanguageContext';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Loader2 } from 'lucide-react';

const JoinGroup = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const join = async () => {
      try {
        const response = await apiClient.post(`/groups/join/${token}`);
        toast.success(t('groupJoined'));
        navigate('/friends');
      } catch (err) {
        console.error('Failed to join group:', err);
        const detail = err.response?.data?.detail || t('invalidInviteLink');
        setError(detail);
        toast.error(detail);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      join();
    }
  }, [token, navigate, t]);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-4">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
        <p className="text-muted-foreground">{t('joiningGroup')}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-md mx-auto mt-20 px-4">
        <Card className="border-red-500/20 bg-red-500/5">
          <CardHeader>
            <CardTitle className="text-red-500">{t('error') || 'Error'}</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm">{error}</p>
            <button 
              onClick={() => navigate('/friends')}
              className="mt-6 text-sm font-medium text-primary hover:underline"
            >
              {t('backToFriends') || 'Back to Friends'}
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return null;
};

export default JoinGroup;
